
import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

import ViewCustomiseDealershipWarrantyProduct from './ViewCustomiseDealershipWarrantyProduct';
import ViewBroutureDealershipWarrantyProduct from '../../Admin/ManageWarantyProducts/ViewBrotureWarrantyProduct';
import PricingPage from './PricingPage';

function CustomTabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function BrotureHome() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', marginTop: '50px' }}>
      {/* <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Broture" {...a11yProps(0)} />
         
        </Tabs>
      </Box> */}

      {/* <CustomTabPanel value={value} index={0}> */}
        <PricingPage />
      {/* </CustomTabPanel> */}

      {/* <CustomTabPanel value={value} index={1}>
        <ViewCustomiseDealershipWarrantyProduct />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={2}>
        <ViewBroutureDealershipWarrantyProduct />
      </CustomTabPanel> */}
    </Box>
  );
}
